<template>
  <div id="actioncable-status" class="pg-admissionlist__action_cable_status__status">
    <template v-if="connect_status == consts.ACTION_CABLE.DEFAULT">
      <img v-bind:src="require('assets/images/synchronize_manual_gray.png')" class="pg-admissionlist__action_cable_status__status-icon">
      <span class="pg-admissionlist__action_cable_status__action-cable-label">同期準備中</span>
    </template>
    <template v-else-if="connect_status == consts.ACTION_CABLE.CONNETED">
      <img v-bind:src="require('assets/images/synchronizing_green.png')" class="pg-admissionlist__action_cable_status__icon__synchronizing pg-admissionlist__action_cable_status__status-icon">
      <span class="pg-admissionlist__action_cable_status__action-cable-label">同期中</span>
    </template>
    <template v-else-if="connect_status == consts.ACTION_CABLE.DIS_CONNECTED">
      <div v-on:click="reload" class="pg-admissionlist__action_cable_status__wrap">
        <img v-bind:src="require('assets/images/synchronize_start_gray.png')" :class="{'pg-admissionlist__action_cable_status__icon__synchronizing': is_click_icon}" class="pg-admissionlist__action_cable_status__status-icon">
        <span class="pg-admissionlist__action_cable_status__action-cable-label">同期開始</span>
      </div>
    </template>
    <template v-else-if="connect_status == consts.ACTION_CABLE.NON_TARGET">
      <div v-on:click="reload" class="pg-admissionlist__action_cable_status__wrap">
        <img v-bind:src="require('assets/images/synchronize_manual_gray.png')" :class="{'pg-admissionlist__action_cable_status__icon__synchronizing': is_click_icon}" class="pg-admissionlist__action_cable_status__status-icon">
        <span class="pg-admissionlist__action_cable_status__action-cable-label">更新する</span>
      </div>
    </template>
  </div>
</template>

<script>
import consts from '../utils/consts'

export default {
  props: {
  },
  data() {
    return {
      is_click_icon: false,
    }
  },

  computed: {
    connect_status: function() {
      return this.$store.getters['actioncable/connect_status']
    },
    consts: function() {
      return consts
    }
  },

  methods: {
    // ページ更新
    reload: function () {
      this.is_click_icon = true
      location.reload()
    }
  }
}
</script>


<style scoped>
  @import '../packs/application.css';

  .pg-admissionlist__action_cable_status__status {
    position: relative;
  }

  .pg-admissionlist__action_cable_status__wrap {
    width: 100px;
  }

  .pg-admissionlist__action_cable_status__action-cable-label {
    position: absolute;
    bottom: 0;
    padding-left: 5px;
  }

  .pg-admissionlist__action_cable_status__status-icon {
    width: 20px;
    height: 20px;
  }

  .pg-admissionlist__action_cable_status__icon__synchronizing {
    -webkit-animation: icon-round 3s linear infinite;
    -moz-animation: icon-round 3s linear infinite;
    -ms-animation: icon-round 3s linear infinite;
    -o-animation: icon-round 3s linear infinite;
    animation: icon-round 3s linear infinite;
  }

  @-webkit-keyframes icon-round {
  	0% {-webkit-transform: rotate(0deg);}
  	100% {-webkit-transform: rotate(360deg);}
  }
  @-moz-keyframes icon-round {
  	0% {-moz-transform: rotate(0deg);}
  	100% {-moz-transform: rotate(360deg);}
  }
  @-ms-keyframes icon-round {
  	0% {-ms-transform: rotate(0deg);}
  	100% {-ms-transform: rotate(360deg);}
  }
  @-o-keyframes icon-round {
  	0% {-o-transform: rotate(0deg);}
  	100% {-o-transform: rotate(360deg);}
  }
  @keyframes icon-round {
  	0% {transform: rotate(0deg);}
  	100% {transform: rotate(360deg);}
  }

</style>
